export default "__VITE_ASSET__B738U8Ha__"